import $http from "./http";
import config from "./config";
export default {
  name: "adapter",
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  getExtraList(data) {
    return $http.post(this.getUrl(`/ExtraInfo/List`), data);
  },
  getExtraInfo(id) {
    return $http.get(this.getUrl(`/ExtraInfo/Details/${id}`));
  },
  saveExtraInfo(data) {
    return $http.post(this.getUrl(`/ExtraInfo/Save`), data);
  },
  getTransform(user_id, redirect_uri) {
    return $http.get(this.getUrl(`Tunnel/transform?user_id=${user_id}&redirect_uri=${redirect_uri}`));
  },
  delete(id) {
    return $http.get(this.getUrl("/ExtraInfo/Delete?id=" + id));
  },
  getSceneInfoList(data) {
    return $http.post(this.getUrl("/sceneinfo/list"), data);
  },
  getSceneInfo(id) {
    return $http.get(this.getUrl("/sceneinfo/details/" + id));
  },
  saveSceneInfo(data) {
    return $http.post(this.getUrl("/sceneinfo/save"), data);
  },
  deleteSceneInfo(id) {
    return $http.get(this.getUrl("/sceneinfo/delete" + id));
  },
  getAdviseUpdate(data) {
    return $http.post(this.getUrl(`/advise/update`), data);
  },
  getAdviseList(data) {
    return $http.post(this.getUrl(`/advise/List`), data);
  },
  getAdviseDetails(id) {
    return $http.get(this.getUrl(`/advise/Details/${id}`));
  },

  deleteExtraInfo(id) {
    return $http.get(this.getUrl(`/ExtraInfo/Delete/${id}`));
  },
  getSettingList(data) {
    return $http.post(this.getUrl("/settinginfo/list"), data);
  },
  getSettingInfo(id) {
    return $http.get(this.getUrl("/settinginfo/details?id=" + id));
  },
  saveSettingInfo(data) {
    return $http.post(this.getUrl("/settinginfo/Save"), data);
  },
  deleteSettingInfo(id) {
    return $http.get(this.getUrl(`/settinginfo/Delete/${id}`));
  },
  smsList(data){
    return $http.post(this.getUrl('/smsinfo/list'),data);
  },
  getSmsInfo(id){
    return $http.get(this.getUrl('/smsinfo/Details?id='+id));
  },
  saveSmsInfo(data){
    return $http.post(this.getUrl('/smsinfo/save'),data);
  },
  quantityUpdate(data){
    return $http.post(this.getUrl('/smsinfo/QuantityUpdate'),data)
  },
  runrule(){
    return $http.get(this.getUrl('/smsinfo/RunRule'));
  },
  checkapproval(data){
    return $http.post(this.getUrl('/EmailProject/detail'),data ,{
      failTips: false
  })
  },
  getTaskplanlist(data){
    return $http.post(this.getUrl('/TaskPlan/List'),data)
  },
  saveTaskplan(data){
    return $http.post(this.getUrl('/TaskPlan/Save'),data)
  },
  saveAppinfo(data){
    return $http.post(this.getUrl('/appinfomodel/save'),data);
  },
  getAppinfo(code){
    return $http.get(this.getUrl('/appinfomodel/Details?appcode='+code),{failTips:false});
  },
  sendCode(phone){
    return $http.get(this.getUrl('/auth/SendCode?phone='+phone));
  },
  updateouterId(data){
    return $http.post(this.getUrl('/auth/AcountVaild'),data)
  },
  searchUserBudgetInfo(certNo) {
    return $http.post(this.getUrl(`/budget/SearchUserBudgetInfo?certNo=${certNo}`));
  },
};



// WEBPACK FOOTER //
// ./src/apis/adapterApis.js